/**
 * Shared password policy for account creation and password changes, so the
 * live requirement checklist and the on-submit gate always enforce the same
 * rules. Consumed by the Sign Up form and the Profile → Change Password form.
 */
export const passwordValidations = [
    { text: '8-16 characters',     check: (pw) => pw.length >= 8 && pw.length <= 16 },
    { text: '1 uppercase letter',  check: (pw) => /[A-Z]/.test(pw) },
    { text: '1 lowercase letter',  check: (pw) => /[a-z]/.test(pw) },
    { text: '1 number',            check: (pw) => /[0-9]/.test(pw) },
    { text: '1 special character', check: (pw) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pw) },
];

// Valid only when every listed requirement passes — keeps the gate in lockstep
// with the checklist the user sees.
export const isPasswordValid = (pw = '') => passwordValidations.every((v) => v.check(pw));
